/**
 * Scrolls to an element by its ID with smooth behavior
 * @param elementId - The ID of the element to scroll to
 * @param options - Optional scroll options (defaults to smooth scroll to start)
 */
export const scrollToElement = (
  elementId: string,
  options: ScrollIntoViewOptions = {
    behavior: 'smooth',
    block: 'start',
  }
) => {
  const element = document.getElementById(elementId);
  if (element) {
    element.scrollIntoView(options);
  }
};

/**
 * Scrolls to the apply form component
 */
export const scrollToApplyForm = () => {
  scrollToElement('apply-form');
};
